module.exports = "/images/icon_social_fb_color.png?cf75ca4c399d235efcca8f45e1c292f4";